import './ErrorBox.scss';

import React from 'react';

export default function ErrorBox({ message }: { message: string }) {
    return <div className="errorBox">{message}</div>;
}
